export const HistorySelector = {
  Primary: {
    state: (state) => state.history.primary,
    loading: (state) => HistorySelector.Primary.state(state).loading,
    updating: (state) => HistorySelector.Primary.state(state).updating,
    histories: (state) => HistorySelector.Primary.state(state).histories,
    goBackFromCustomerInfoPage: (state) => HistorySelector.Primary.state(state).goBackFromCustomerInfoPage,
    filterTransactionDate: (state) => HistorySelector.Primary.state(state).filterTransactionDate,
    paginable: (state) => HistorySelector.Primary.state(state).paginable,
    total: (state) => HistorySelector.Primary.state(state).total,
    endPaging: (state) => HistorySelector.Primary.state(state).endPaging,
  },
  Secondary: {
    state: (state) => state.history.secondary,
    loading: (state) => HistorySelector.Secondary.state(state).loading,
    fetchingDetail: (state) => HistorySelector.Secondary.state(state).fetchingDetail,
    updating: (state) => HistorySelector.Secondary.state(state).updating,
    histories: (state) => HistorySelector.Secondary.state(state).histories,
    goBackFromCustomerInfoPage: (state) => HistorySelector.Primary.state(state).goBackFromCustomerInfoPage,
    paginable: (state) => HistorySelector.Secondary.state(state).paginable,
    total: (state) => HistorySelector.Secondary.state(state).total,
    endPaging: (state) => HistorySelector.Secondary.state(state).endPaging,
    filterTransactionDate: (state) => HistorySelector.Secondary.state(state).filterTransactionDate,
    transactionType: (state) => HistorySelector.Secondary.state(state).transactionType,
  },
  WithholdingTax: {
    state: (state) => state.history.withholdingTax,
    loading: (state) => HistorySelector.WithholdingTax.state(state).loading,
    year: (state) => HistorySelector.WithholdingTax.state(state).year,
    histories: (state) => HistorySelector.WithholdingTax.state(state).histories,
    total: (state) => HistorySelector.WithholdingTax.state(state).total,
    paginable: (state) => HistorySelector.WithholdingTax.state(state).paginable,
    endPaging: (state) => HistorySelector.WithholdingTax.state(state).endPaging,
  },
  StructureNote: {
    state: (state) => state.history.structureNote,
    loading: (state) => HistorySelector.StructureNote.state(state).loading,
    updating: (state) => HistorySelector.StructureNote.state(state).updating,
    histories: (state) => HistorySelector.StructureNote.state(state).histories,
    goBackFromCustomerInfoPage: (state) => HistorySelector.StructureNote.state(state).goBackFromCustomerInfoPage,
    filterTransactionDate: (state) => HistorySelector.StructureNote.state(state).filterTransactionDate,
    paginable: (state) => HistorySelector.StructureNote.state(state).paginable,
    total: (state) => HistorySelector.StructureNote.state(state).total,
    endPaging: (state) => HistorySelector.StructureNote.state(state).endPaging,
  },
};
